import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_ERROR,
  AUTH_CHECK,
  AUTH_GET_PERMISSIONS
} from 'react-admin';

import firebase from 'firebase';
import { AuthService } from '../services';

const authService = new AuthService();

export const AuthProvider = (type, params) => {
  if (type === AUTH_LOGIN) {
    console.log('AUTH_LOGIN');
    const { username, password } = params;
    return firebase
      .auth()
      .signInWithEmailAndPassword(username, password)
      .then(result => {
        const { uid } = result.user;
        return authService.isAdmin(uid);
      });
  } else if (type === AUTH_CHECK) {
    console.log('AUTH_CHECK');
    return new Promise((resove, reject) => {
      const unsubscribe = firebase.auth().onAuthStateChanged(user => {
        const isconnected = user != null;
        unsubscribe();
        return isconnected ? resove() : reject();
      });
    });
  } else if (type === AUTH_LOGOUT) {
    console.log('AUTH_LOGOUT');
    firebase.auth().signOut();
    return Promise.resolve();
  } else if (type === AUTH_ERROR) {
    console.log('AUTH_ERROR');
    const { status } = params;
    if (status === 401 || status === 403) {
      firebase.auth().signOut();
      return Promise.reject();
    }
    return Promise.resolve();
  } else if (type === AUTH_GET_PERMISSIONS) {
    console.log('AUTH_GET_PERMISSIONS');

    return new Promise((resolve, reject) => {
      const unsubscribe = firebase.auth().onAuthStateChanged(user => {
        unsubscribe();
        if (user) {
          let userId = user.uid;
          return authService
            .authRole(userId)
            .then(role => resolve(role))
            .catch(reject);
        } else reject();
      });
    });
  } else {
    return Promise.reject('Unknown method');
  }
};



// WEBPACK FOOTER //
// ./src/providers/authProvider.js